import { render, staticRenderFns } from "./HRCDetails.vue?vue&type=template&id=4cb15e56&"
import script from "./HRCDetails.vue?vue&type=script&lang=js&"
export * from "./HRCDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports